import { useState, useEffect, useRef } from "react";
import { infosCardsMapper } from "../utils/mapper/infos_cards_mapper.jsx";

export const useInfosCardsViewModel = () => {
    const { observerConfig, animationDelays } = infosCardsMapper;
    const [cards, setCards] = useState([false, false, false, false]);
    const [hasAnimated, setHasAnimated] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !hasAnimated) {
                        setHasAnimated(true);
                        setTimeout(() => setCards([true, false, false, false]), animationDelays[0]);
                        setTimeout(() => setCards([true, true, false, false]), animationDelays[1]);
                        setTimeout(() => setCards([true, true, true, false]), animationDelays[2]);
                        setTimeout(() => setCards([true, true, true, true]), animationDelays[3]);
                        observer.unobserve(entry.target);
                    }
                });
            },
            observerConfig
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [hasAnimated, observerConfig, animationDelays]);

    return {
        cards,
        sectionRef,
    };
};
